import { Outlet } from 'react-router-dom'
import { MockBar } from '@/mocks/mock-bar'
import { Toaster } from '@/components/ui/sonner'

/** Wraps every route so dev-only chrome sits above both login and the console. */
export function RootLayout() {
  return (
    <div className="flex h-full flex-col">
      <MockBar />
      <div className="min-h-0 flex-1">
        <Outlet />
      </div>
      {/*
        Mounted here, above the router outlet, because every screen calls
        `toast.*` and none of them render their own host. Without it the whole
        console is silent: a duplicate key answers 409 and nothing appears, a
        rename succeeds and nothing confirms it, a retranslate that never lands
        warns into the void. The calls were all present — there was simply
        nowhere for them to go.
      */}
      <Toaster />
    </div>
  )
}
